import axios from "axios";
import React, { useEffect, useState } from "react";
import LoadingAnimation from "../reusables/LoadingAnimation";

const AudioDuration = ({ url }) => {
  const [duration, setDuration] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAudioDuration = async () => {
      try {
        const audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();

        // Fetch binary audio data
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}audio/get`,
          { url },
          { responseType: "arraybuffer" } // Expect binary data
        );

        // Validate ArrayBuffer
        if (!(response.data instanceof ArrayBuffer)) {
          throw new Error("Received invalid audio data");
        }

        // Decode audio data
        const audioBuffer = await audioContext.decodeAudioData(response.data);
        setDuration(audioBuffer.duration); // Set duration
      } catch (error) {
        // Log when audio decode fails (unsupported format or corrupt data)
        console.error("Error decoding audio file:", error);
        setDuration(null); // Handle failure
      } finally {
        setLoading(false);
      }
    };

    fetchAudioDuration();
  }, [url]);

  return (
    <div>
      {loading ? (
        <img
          src="/icons/loading-spinner.gif"
          className="w-[24px] ml-4 cursor-pointer"
          alt="Loading"
        />
      ) : duration !== null ? (
        <div>{duration.toFixed(2)}s</div> // Display duration rounded to 2 decimals
      ) : (
        <div>Error loading audio</div>
      )}
    </div>
  );
};

export default AudioDuration;
